import { h, render } from 'preact'
import { useState } from 'preact/hooks';

const HoverImage = ({ src, hoverSrc, onClick }) => {
    const [hovered, toggleHovered] = useState(false);
    const imgSrc = hovered ? hoverSrc : src;

    return (
        
        <img class="nm-hover-img" src={ require(`../images/${imgSrc}`) }
            onMouseOver={ () => toggleHovered(true) }
            onMouseOut={ () => toggleHovered(false) }
            onClick={ onClick }
        />
    )
}

export default HoverImage
